import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import DeleteConfirmation from '../../components/delete-confirmation';
import { closeModal } from '../../actions/close-modal';
import withTranslate from '../../hoc/with-translate';

export const DeleteCommentModal = ({ closeModal, deleteComment, t }) =>
  <Modal onClose={closeModal}>
    <DeleteConfirmation
      title={t('delete-comment-modal.delete-comment')}
      message={t('delete-comment-modal.are-you-sure')}
      onConfirm={deleteComment}
      onCancel={closeModal}
    />
  </Modal>;

DeleteCommentModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  deleteComment: PropTypes.func.isRequired,
  postId: PropTypes.string.isRequired,
  commentId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      closeModal,
      deleteComment: () =>
        closeModal({
          postId: ownProps.postId,
          commentId: ownProps.commentId,
        }),
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(withTranslate(DeleteCommentModal));



// WEBPACK FOOTER //
// ./app/containers/delete-comment-modal/delete-comment-modal.js